import { render, staticRenderFns } from "./playerThisSeasonRecord.vue?vue&type=template&id=a0ffa9ae&scoped=true"
import script from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
export * from "./playerThisSeasonRecord.vue?vue&type=script&lang=js"
import style0 from "./playerThisSeasonRecord.vue?vue&type=style&index=0&id=a0ffa9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ffa9ae",
  null
  
)

export default component.exports